import {
  SSO_SESSION_ACTIVE,
  SSO_SESSION_INACTIVE,
  SSO_SESSION_ERROR,
  GEO_IP_SUCCESS,
  GEO_IP_FAILED,
  USER_LOGGED_OUT,
} from 'actions/auth';
import * as userActions from 'actions/user';
import { getStorage } from 'utils/storageHelpers';
import debug from 'debug';

const log = debug('sagas:auth');
const cachedToken = getStorage(window.localStorage, 'spWgToken');

// Note that booleans are stored as strings in localStorage
const cachedIsWhitelisted = getStorage(window.localStorage, 'adgen-whitelisted');
const visitedBeforeCacheInPlace = cachedIsWhitelisted === null;
log('cache is whitelisted', cachedIsWhitelisted);

const initialState = {
  // Ensures that folks deep linking in (before the cache was in place) have deep links preserved
  isWhitelisted: visitedBeforeCacheInPlace || cachedIsWhitelisted !== 'false',
  isAuthenticated: !!cachedToken,
  token: cachedToken,
  country: null,
  errorMessage: '',
  hasLoginError: false,
};

log('user has local storage?', !!window.localStorage);
log('user initial auth state', initialState);

export default function auth(state = initialState, action) {
  switch (action.type) {
    case SSO_SESSION_ACTIVE:
      return {
        ...state,
        isAuthenticated: true,
        token: action.accessToken,
        errorMessage: '',
        hasLoginError: false,
      };
    case SSO_SESSION_INACTIVE:
      return {
        ...state,
        isAuthenticated: false,
        errorMessage: '',
        hasLoginError: false,
      };
    case SSO_SESSION_ERROR:
      return {
        ...state,
        isAuthenticated: false,
        errorMessage: action.err.message,
        hasLoginError: true,
      };
    case userActions.RECEIVE_USER_INFO:
      return {
        ...state,
        isWhitelisted: !!Object.keys(action.user.groups).length,
      };
    case GEO_IP_SUCCESS:
      return {
        ...state,
        country: action.payload.country,
      };
    case GEO_IP_FAILED:
      return {
        ...state,
        country: null,
      };
    case USER_LOGGED_OUT:
      return {
        ...state,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js